/**
 * AlertStatusBadge — color-coded status badge; hover, focus or tap explains it
 * (InfoPopover).
 *
 * When status is "Overdue", pass eventDateTime so the badge can distinguish
 * between yellow (>10 min) and red/critical (>20 min).
 */

import InfoPopover from '../../../../components/v2/InfoPopover.jsx';

const CRITICAL_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutes

const STATUS_CLASSES = {
    Waiting: 'na-status--waiting',
    Overdue: 'na-status--overdue',
    Accepted: 'na-status--accepted',
    Cleared: 'na-status--cleared',
    Arrived: 'na-status--arrived',
};

const STATUS_DESCRIPTIONS = {
    Waiting: 'Waiting for alert to be accepted or cleared if accept feature is N/A for device.',
    Overdue: 'Alert has been active over 5 minutes without being accepted or cleared.',
    OverdueCritical: 'Alert has been active over 10 minutes without being accepted or cleared.',
    Accepted: 'Alert has been accepted by a staff member but the device is still in alarm state.',
    Cleared: 'Device has been cleared. If this device is listed for AFR in system settings, it must be accepted and finished through the mobile app.',
    Arrived: 'Staff has accepted the alert and the device\'s alarm state has been cleared. Alert must be finished to close out.',
};

const AlertStatusBadge = ({ status, eventDateTime }) => {
    // Determine if Overdue should be critical (>20 min)
    let isCritical = false;
    if (status === 'Overdue' && eventDateTime) {
        const eventTime = new Date(eventDateTime.endsWith?.('Z') ? eventDateTime : eventDateTime + 'Z').getTime();
        isCritical = Date.now() - eventTime > CRITICAL_THRESHOLD_MS;
    }

    const cls = (status === 'Overdue' && isCritical)
        ? 'na-status--overdue-critical'
        : (STATUS_CLASSES[status] || 'na-status--accepted');
    const desc = (status === 'Overdue' && isCritical)
        ? STATUS_DESCRIPTIONS.OverdueCritical
        : (STATUS_DESCRIPTIONS[status] || '');

    const badge = <span className={`na-status ${cls}`}>{status || '—'}</span>;
    if (!desc) return badge;

    return (
        <InfoPopover marker="none" body={desc} maxWidth={280}>
            {badge}
        </InfoPopover>
    );
};

export default AlertStatusBadge;
